import { required } from 'vuelidate/lib/validators'

const departamentoEhVazio = (value,vm) => !(vm.departamentoEhVazio.length == 0)

const validaDuration = value => {
  if (typeof value === 'undefined' || value === null || value === '') {
    return true
  }
  return /^(?:(?:([01]?\d|2[0-3]):)?([0-5]?\d):)?([0-5]?\d)$/g.test(value)
}

export const validateData = {
  form: {
    operadores: { required },
  },
  maiorQue: { validaDuration },
  departamentosSelecionados:{ departamentoEhVazio }
}

export const validateComputed = {
  operadoresErrors() {
    const errors = []
    if (!this.$v.form.operadores.$dirty) return errors
    !this.$v.form.operadores.required && errors.push('Campo obrigatório.')
    return errors
  },
  
  departamentoErrors(){
    const errors = []
    if (!this.$v.departamentosSelecionados.$dirty) return errors
    !this.$v.departamentosSelecionados.departamentoEhVazio && errors.push('Departamento Vazio.')
    !this.$v.form.operadores.required && errors.push('Campo obrigatório.')
    return errors
  },

  maiorQueErrors() {
    const errors = []
    if (!this.$v.maiorQue.$dirty) return errors
    !this.$v.maiorQue.validaDuration && errors.push('Formato inválido')
    return errors
  },

}
